import React from "react";
import "./resetpassword.scss";
import { images } from "../../utils/customFn";
import useResetPasswordUtils from "./useResetpasswordUtils";
import { EyeClosedIcon, EyeOpenIcon } from "../../icon/icons";

const ResetPassword = () => {
  const {
    formData,
    formErrors,
    loading,
    handleChange,
    handleSubmit,
    showConfirmPassword,
    showNewPassword,
    togglePassword
  } = useResetPasswordUtils();

  console.log("formErrors", formErrors);

  return (
    <div className="login_main_page">
      <div className="page_side_pd">
        <div className="page_flex_data">
          <div className="page_form_data">
            <div className="form-inner-data">
              <div className="logo_container">
                <img src={images["side_logo.png"]} alt="" className="logo" />
              </div>
              <div className="page_heading"></div>
              <form onSubmit={handleSubmit}>
                <div className="password-fields">
                <div className="input-main-data ">
                  <label>New Password</label>
                  <div className="password-input-wrapper">
                    <input
                      type={showNewPassword ? "text" : "password"}
                      name="newPassword"
                      onChange={handleChange}
                      autoComplete="new-password"
                      value={formData.newPassword}
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      onClick={() => togglePassword("new")}
                    >
                      {showNewPassword ?<EyeOpenIcon /> :  <EyeClosedIcon /> }
                    </button>
                  </div>
                  {formErrors.newPassword && (
                    <div className="error_message">
                      {formErrors.newPassword}
                    </div>
                  )}
                </div>

                <div className="input-main-data">
                  <label>Confirm Password</label>
                  <div className="password-input-wrapper">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirmPassword"
                      onChange={handleChange}
                      autoComplete="new-password"
                      value={formData.confirmPassword}
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      onClick={() => togglePassword("confirm")}
                    >
                      {showConfirmPassword ? (
                        <EyeOpenIcon />
                        
                      ) : (
                        <EyeClosedIcon />
                      )}
                    </button>
                  </div>
                  {formErrors.confirmPassword && (
                    <div className="error_message">
                      {formErrors.confirmPassword}
                    </div>
                  )}
                </div>
                </div>

                <div className="btn_main_login">
                  <button
                    type="submit"
                    className="btn-comman-main"
                    disabled={loading}
                  >
                    {"Reset Password"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
